import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "error"]
  static values = { message: { type: String, default: "Enter a valid URL." } }

  validate() {
    const value = this.inputTarget.value.trim()
    if (!value || this.validUrl(value)) {
      this.clear()
      return
    }

    this.show()
  }

  validUrl(value) {
    try {
      const candidate = /^https?:\/\//i.test(value) ? value : `https://${value}`
      const url = new URL(candidate)
      return url.protocol === "http:" || url.protocol === "https:"
    } catch (_error) {
      return false
    }
  }

  show() {
    this.inputTarget.setAttribute("aria-invalid", "true")
    this.element.classList.add("has-error")
    if (this.hasErrorTarget) {
      this.errorTarget.hidden = false
      this.errorTarget.textContent = this.messageValue
    }
  }

  clear() {
    this.inputTarget.removeAttribute("aria-invalid")
    this.element.classList.remove("has-error")
    if (this.hasErrorTarget) {
      this.errorTarget.hidden = true
      this.errorTarget.textContent = ""
    }
  }
}
